module.exports = __webpack_public_path__ + "static/instagram-0cdc7ebd86b8a010401634bfef11c931.png";